// extracted by mini-css-extract-plugin
module.exports = {"componentsError":"styles_componentsError__2NYPp"};